import React from 'react';
import { Stack } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';
import { CurrencyInputField, InterestInputField, SwitchField } from 'components/form';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { ProductConfig } from '../../../../types';

interface Props {
  rowIndex: number;
}

export const RateFactorCell = ({ rowIndex }: Props) => {
  const { control, setValue } = useFormContext<ListingForm<ProductConfig>>();
  const isUseRateFactor = useWatch({ control, name: `bodyFields.${rowIndex}.cost.isUseRateFactor` });

  return (
    <Stack>
      <SwitchField
        label="Use Rate Factor"
        control={control}
        name={`bodyFields.${rowIndex}.cost.isUseRateFactor`}
        extraAction={() => {
          setValue(`bodyFields.${rowIndex}.cost.value`, 0);
        }}
      />

      <RenderWithCondition
        condition={!isUseRateFactor}
        fallBack={
          <InterestInputField
            control={control}
            decimalScale={6}
            textFieldProps={{ variant: 'outlined' }}
            name={`bodyFields.${rowIndex}.cost.value`}
          />
        }
      >
        <CurrencyInputField
          control={control}
          textFieldProps={{ variant: 'outlined' }}
          name={`bodyFields.${rowIndex}.cost.value`}
        />
      </RenderWithCondition>
    </Stack>
  );
};
